/**
 * Draft/publish readiness warnings for Bounding Box — project settings context.
 * Invoked via uiRegistry (`bounding-box`); inspects annotationUI.config only.
 */

import { validateBoundingBoxConfig } from './boundingBoxModel';

export function getBoundingBoxConfigPublishWarnings(annotationUI) {
    const issues = validateBoundingBoxConfig(annotationUI?.config);
    return issues.map((i) => i.message);
}
